<template>
  <div class="body-wrapper community-tickets">
    <table-tickets></table-tickets>
  </div>
</template>

<script>
import TableTickets from '@/components/table/TableTickets.vue';
import { mapMutations, mapActions } from 'vuex';

export default {
  components: {
    TableTickets
  },
  created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();
    //loading data to table
    const params = this.$route.query;
    if (!Array.isArray(params.status) && params.status) {
      params.status = [params.status];
    }
    if (!Array.isArray(params.priority) && params.priority) {
      params.priority = [Number(params.priority)];
    }
    this.getTicketsByCommunity({
      memberId: this.$store.getters.getActiveCommunity.member_id,
      communityId: this.$store.getters.getActiveCommunity.id,
      params
    });
  },
  methods: {
    ...mapActions('table', ['getTicketsByCommunity']),
    ...mapMutations(['cardOpened'])
  }
};
</script>

<style lang="scss"></style>
